"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var xhrResponseTypeSupport=exports.xhrResponseTypeSupport=function(){var e=new XMLHttpRequest;if("responseType"in e){try{e.responseType="json"}catch(e){console.warn("XMLHttpRequest.responseType = 'json' not supported.")}if("json"===e.responseType)return!0}},responseToJSON=exports.responseToJSON=xhrResponseTypeSupport()?function(e){return e}:function(e){return JSON.parse(e)};
//# sourceMappingURL=utils.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@convotis/liferay-client/lib/utils.js
// module id = 175
// module chunks = 4